import React from 'react';
import { ITranslateProps, translate } from '../../../mixins/translate';
import { Component } from '../../utils/Component';
import { NullableFormattedDate } from '../../utils/NullableFormattedDate';
import { ICategory } from '../Interfaces/ICategory';
import { IElement } from '../Interfaces/IElement';

interface IRepairListProps extends ITranslateProps {
    elements: IElement[];
    categories: ICategory[];
}

class RepairList extends Component<IRepairListProps> {
    private hasRepairAdviceCategories(): boolean {
        // Check if there are any defects with repair advice categories
        return this.props.categories.some((category) =>
            this.props.elements
                .filter((element: any) => element.categoryId === category.id)
                .some((element) => {
                    // Check element defects
                    if (element.defects && element.defects.some((defect) => defect.repairAdviceCategory)) {
                        return true;
                    }
                    // Check unit defects
                    if (element.units && element.units.some((unit) => unit.defects && unit.defects.some((defect) => defect.repairAdviceCategory))) {
                        return true;
                    }
                    return false;
                }),
        );
    }
    public override render() {
        // If there are no defects with repair advice categories, don't render the table
        if (!this.hasRepairAdviceCategories()) {
            return null;
        }
        return (
            <div className="panel" id="Repair">
                <div className="panel-heading">
                    <span className="panel-title">
                        <span className="fa fa-wrench" />
                        {this.props.t('repairAdvice.repairAdvice')}
                    </span>
                </div>
                <div className="panel-body pn">
                    <table className="table">
                        <thead>
                            <tr className="bg-light">
                                <th>{this.props.t('repairAdvice.category')}</th>
                                <th>{this.props.t('repairAdvice.advice')}</th>
                                <th>{this.props.t('repairAdvice.eemua')}</th>
                                <th>{this.props.t('repairAdvice.repairDate')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.categories.map((category) =>
                                this.props.elements
                                    .filter((element: any) => element.categoryId === category.id)
                                    .map((element, i) => (
                                        <React.Fragment key={`${element.categoryId}${i}`}>
                                            {element.defects &&
                                                element.defects.map((defectElement) => (
                                                    <tr key={defectElement.id}>
                                                        <td>{category.name}</td>
                                                        <td>{defectElement.description}</td>
                                                        <td>{this.props.t(`repairCategory.${defectElement.repairAdviceCategory}`)}</td>
                                                        <td>
                                                            <NullableFormattedDate value={defectElement.repairDate} />
                                                        </td>
                                                    </tr>
                                                ))}
                                            {element.units.map((unit) =>
                                                unit.defects.map((defectUnit) => (
                                                    <tr key={defectUnit.id}>
                                                        <td>{category.name}</td>
                                                        <td>{defectUnit.description}</td>
                                                        <td>{this.props.t(`repairCategory.${defectUnit.repairAdviceCategory}`)}</td>
                                                        <td>
                                                            <NullableFormattedDate value={defectUnit.repairDate} />
                                                        </td>
                                                    </tr>
                                                )),
                                            )}
                                        </React.Fragment>
                                    )),
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(RepairList);
